// src/admin/pages/CreateCohort.jsx
import React, { useEffect, useState } from "react";
import { adminService } from "../../services/adminService";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";

const CreateCohort = () => {
  const navigate = useNavigate();
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    name: "",
    course_id: "",
    start_date: "",
    end_date: "",
    description: "",
    status: "planned",
  });

  useEffect(() => {
    adminService.getCourses().then((data) => setCourses(data));
  }, []);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async () => {
    try {
      setLoading(true);
      await adminService.createCohort(form);
      navigate("/admin/cohorts");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-8 max-w-3xl">

      {/* Page Title */}
      <h1 className="text-display">Create New Cohort</h1>

      {/* Form Card */}
      <div className="bg-white shadow rounded-lg stakeholder-summary-card p-8 space-y-6">

        {/* Name */}
        <div className="flex flex-col gap-1">
          <label className="text-title">Name</label>
          <input
            type="text"
            name="name"
            className="border p-3 rounded-md stakeholder-input"
            placeholder="Cohort name"
            value={form.name}
            onChange={handleChange}
          />
        </div>

        {/* Course */}
        <div className="flex flex-col gap-1">
          <label className="text-title">Course</label>
          <select
            name="course_id"
            className="border p-3 rounded-md stakeholder-dropdown"
            value={form.course_id}
            onChange={handleChange}
          >
            <option value="">Select Course</option>
            {courses.map((c) => (
              <option key={c.id} value={c.id}>
                {c.title}
              </option>
            ))}
          </select>
        </div>

        {/* Dates */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

          <div className="flex flex-col gap-1">
            <label className="text-title">Start Date</label>
            <input
              type="date"
              name="start_date"
              className="border p-3 rounded-md stakeholder-input"
              value={form.start_date}
              onChange={handleChange}
            />
          </div>

          <div className="flex flex-col gap-1">
            <label className="text-title">End Date</label>
            <input
              type="date"
              name="end_date"
              className="border p-3 rounded-md stakeholder-input"
              value={form.end_date}
              onChange={handleChange}
            />
          </div>
        </div>

        {/* Description */}
        <div className="flex flex-col gap-1">
          <label className="text-title">Description</label>
          <textarea
            name="description"
            rows={4}
            className="border p-3 rounded-md stakeholder-input"
            placeholder="Describe this cohort"
            value={form.description}
            onChange={handleChange}
          />
        </div>

        {/* Submit Button */}
        <button
          onClick={handleSubmit}
          disabled={loading}
          className="w-full bg-[#54B0AF] text-white py-3 rounded-md text-sm font-medium hover:opacity-90 transition flex items-center justify-center gap-2 shadow"
        >
          {loading && <Loader2 className="animate-spin" size={18} />}
          {loading ? "Creating..." : "Create Cohort"}
        </button>

      </div>
    </div>
  );
};

export default CreateCohort;
